import { render, staticRenderFns } from "./BoardEdit.vue?vue&type=template&id=41d01357&scoped=true"
import script from "./BoardEdit.vue?vue&type=script&lang=js"
export * from "./BoardEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d01357",
  null
  
)

export default component.exports